import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import graphReducer from "./graph/reducer";
import globalReducer from "./global/reducer";
import portfolioReducer from "./portfolio/reducer";
import generalReducer from "./general/reducer";
import userReducer from "./user/reducer";
const rootReducer = combineReducers({
    graphReducer,
    globalReducer,
    portfolioReducer,
    userReducer,
    generalReducer,
});
const store = createStore(rootReducer, applyMiddleware(thunk));
export { store };
